import styled from "styled-components";
import BigNumber from "bignumber.js";
import {
  Text,
  useMatchBreakpoints,
  TokenPairImage as UITokenPairImage,
  Box,
  Flex,
} from "@pancakeswap/uikit";
import Balance from "components/Balance";
// import { useTranslation } from 'contexts/Localization'
// import { useVaultPoolByKey } from 'state/pools/hooks'
// import { BIG_ZERO } from 'utils/bigNumber'
// import { vaultPoolConfig } from 'config/constants/pools'
import { TokenPairImage } from "components/TokenImage";
import BaseCell, { CellContent } from "./BaseCell";
import pancake from "../../../../../assets/images/pancake.svg";
import drivenx from "../../../../../assets/images/drivenx.png";
import { ethers } from "ethers";
import { Avatar } from "@mui/material";
import { useWeb3React } from "@web3-react/core";

interface NameCellProps {
  pool: any;
}

const StyledCell = styled(BaseCell)`
  /* flex: 5; */
  flex-direction: row;
  padding-left: 0px;
  ${({ theme }) => theme.mediaQueries.xs} {
   min-width:70px;
  }
  ${({ theme }) => theme.mediaQueries.sm} {
    min-width:150px;
    margin-right: 0px;
  }
  ${({ theme }) => theme.mediaQueries.md} {
     /* flex:2; */
  }
  ${({ theme }) => theme.mediaQueries.xl} {
     /* flex:2; */
     /* min-width:170px; */
     /* padding-right: 70px; */
  }
`;
const Fees = styled.div`
 padding-top : 2px;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: start;
`;

const NameCell: React.FC<NameCellProps> = ({ pool }) => {
  const { isMobile } = useMatchBreakpoints();
  const { error, connector, activate, deactivate, library, active, account } = useWeb3React();
  // const stakingTokenSymbol = stakingToken.symbol;
  // const earningTokenSymbol = earningToken.symbol;

  // let title: React.ReactNode = `${"Earn"} ${earningTokenSymbol}`;
  // let subtitle: React.ReactNode = `${"Stake"} ${stakingTokenSymbol}`;

  // }

  return (
    <StyledCell role="cell">
      <Box position='relative'>
        <Avatar sx={{ width: "40px", height: "40px", borderRadius: "50%", border: '1px solid', borderColor: '#00FED9' }} src={drivenx} alt="drivenx" variant="rounded"></Avatar>
        <Avatar sx={{ position: 'absolute', top: '25px', left: '22px', width: "20px", height: "20px", borderRadius: "50%", border: '1px solid', borderColor: '#00FED9' }} src={drivenx} alt="drivenx" variant="rounded"></Avatar>
      </Box>
      <CellContent>
        <Box marginLeft={"15px"}>
          {(parseFloat(ethers.utils.formatEther(pool.user.userstack)) > 0) && active ? <Text
            lineHeight={1}
            fontSize="10px"
            bold
            color="#00FED9"
            textTransform="uppercase"
          >
            Staked
          </Text>
            :
            ''
          }
          <Text
            lineHeight={1}
            fontSize="16px"
            fontWeight={400}
            color="#00FED9"
            textTransform="capitalize"
          >
            Earn {pool.name}
          </Text>
          <Text lineHeight={1} bold={!isMobile} small={isMobile}>
            {/* {title} */}
          </Text>
          {/* {showSubtitle && ( */}
          <Text lineHeight={1} fontWeight={400} fontSize="12px" color="#B1B3CB">
            {/* Stake {pool.name} */}
            Stake {pool.symbol}
          </Text>
          {/* )} */}
          <Fees>
            {pool.contractType === 'lockup' ? (
              <>

                <Text
                  fontSize="10px"
                  lineHeight={1.5}
                  fontWeight={400}
                  bold
                  color="#00FED9"
                  as="span"
                  textTransform="capitalize"
                >
                  Lock:
                </Text>
                <Flex>
                  <Balance
                    lineHeight="1"
                    fontWeight={400}
                    display="inline"
                    fontSize="10px"
                    color="#00FED9"
                    decimals={0}
                    prefix="&nbsp"
                    value={parseInt(pool.duration.toString())}
                    unit=" Days"
                  />
                </Flex>
              </>
            ) : (
              <></>
            )}

          </Fees>
        </Box>
      </CellContent>
    </StyledCell>
  );
};

export default NameCell;
